import { render, staticRenderFns } from "./cerfaclim.vue?vue&type=template&id=44d71f52&scoped=true&"
import script from "./cerfaclim.vue?vue&type=script&lang=js&"
export * from "./cerfaclim.vue?vue&type=script&lang=js&"
import style0 from "./cerfaclim.vue?vue&type=style&index=0&id=44d71f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d71f52",
  null
  
)

export default component.exports